var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["basedata.province"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "province"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                "show-search": "",
                                optionFilterProp: "label",
                                placeholder:
                                  _vm.language["common.pleaseInput"] +
                                  _vm.language["basedata.province"],
                                disabled: this.disabled
                              },
                              on: { change: _vm.backProvince },
                              model: {
                                value: _vm.model.province,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "province", $$v)
                                },
                                expression: "model.province"
                              }
                            },
                            _vm._l(_vm.provinceOptions, function(d) {
                              return _c(
                                "a-select-option",
                                {
                                  key: d.id,
                                  attrs: { value: d.id, label: d.name }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(d.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["basedata.city"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "city"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                "show-search": "",
                                optionFilterProp: "label",
                                placeholder:
                                  _vm.language["common.pleaseInput"] +
                                  _vm.language["basedata.city"],
                                disabled: this.disabled
                              },
                              model: {
                                value: _vm.model.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "city", $$v)
                                },
                                expression: "model.city"
                              }
                            },
                            _vm._l(_vm.cityOptions, function(d) {
                              return _c(
                                "a-select-option",
                                {
                                  key: d.id,
                                  attrs: { value: d.id, label: d.name }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(d.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["factory.no"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "factoryCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["factory.no"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.factoryCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "factoryCode", $$v)
                              },
                              expression: "model.factoryCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["factory.name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "factoryName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["factory.name"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.factoryName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "factoryName", $$v)
                              },
                              expression: "model.factoryName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "EpBdFactory",
                                    "factoryName",
                                    _vm.nameLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["factory.address"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "address"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["factory.address"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.address,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address", $$v)
                              },
                              expression: "model.address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["system.longitude"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["system.longitude"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.longitude,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "longitude", $$v)
                              },
                              expression: "model.longitude"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["system.latitude"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["system.latitude"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.latitude,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "latitude", $$v)
                              },
                              expression: "model.latitude"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["system.altitude"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["system.altitude"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.altitude,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "altitude", $$v)
                              },
                              expression: "model.altitude"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["system.isVirtual"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              attrs: { disabled: this.disabled },
                              model: {
                                value: _vm.model.virtual,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "virtual", $$v)
                                },
                                expression: "model.virtual"
                              }
                            },
                            [
                              _c("a-radio", { attrs: { value: "1" } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.language["common.yes"]) +
                                    "\n              "
                                )
                              ]),
                              _c("a-radio", { attrs: { value: "0" } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.language["common.no"]) +
                                    "\n              "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }